module.exports = __webpack_public_path__ + "img/jpg_icon.451df7ea.svg";